import React from "react";
import MediaQuery from "react-responsive";

import { withRouteData } from "react-static";
import { withNamespaces } from "react-i18next";

const FACEBOOK_PAGE_URL = `https://m.me/${process.env.REACT_APP_FACEBOOK_PAGE_ID}`;

const LargeMenu = props => {
  const { t, goTo, setLanguage, currentLang } = props;

  return (
    <ul className="main-nav" id="menu">
      <li onClick={() => goTo("/legal")}>
        <a href="/legal" className="nav-links">
          {t("legal")}
        </a>
      </li>

      <li onClick={() => goTo(FACEBOOK_PAGE_URL)}>
        <a href={FACEBOOK_PAGE_URL} className="nav-links">
          {t("contact")}
        </a>
      </li>

      <li>
        <span onClick={() => setLanguage("fr")}>
          <a
            href="#"
            style={{
              marginLeft: "40px",
              marginRight: "5px",
              color: currentLang.startsWith("fr") ? "#72ce07" : "white"
            }}
          >
            {t("language.fr")}
          </a>
        </span>

        <span style={{ color: "white" }}>|</span>

        <span onClick={() => setLanguage("en")}>
          <a
            href="#"
            style={{
              marginLeft: "5px",
              color: currentLang.startsWith("en") ? "#72ce07" : "white"
            }}
          >
            {t("language.en")}
          </a>
        </span>
      </li>
    </ul>
  );
};

export default withNamespaces("translation")(withRouteData(LargeMenu));



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/components/navBar/large-screen-menu.js